(function () {
  'use strict';

  /* @ngdoc object
   * @name edit.download
   * @description
   *
   */
  angular
    .module('edit.download', [
      'ui.router'
    ]);
}());
